/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { StructuredAnalysisResponse } from './StructuredAnalysisResponse';
import {
    StructuredAnalysisResponseFromJSON,
    StructuredAnalysisResponseFromJSONTyped,
    StructuredAnalysisResponseToJSON,
    StructuredAnalysisResponseToJSONTyped,
} from './StructuredAnalysisResponse';
import type { InternalInstructions } from './InternalInstructions';
import {
    InternalInstructionsFromJSON,
    InternalInstructionsFromJSONTyped,
    InternalInstructionsToJSON,
    InternalInstructionsToJSONTyped,
} from './InternalInstructions';
import type { TargetCompany } from './TargetCompany';
import {
    TargetCompanyFromJSON,
    TargetCompanyFromJSONTyped,
    TargetCompanyToJSON,
    TargetCompanyToJSONTyped,
} from './TargetCompany';
import type { CreateCallExecutionRequest } from './CreateCallExecutionRequest';
import {
    CreateCallExecutionRequestFromJSON,
    CreateCallExecutionRequestFromJSONTyped,
    CreateCallExecutionRequestToJSON,
    CreateCallExecutionRequestToJSONTyped,
} from './CreateCallExecutionRequest';
import type { CallExecutionStatus } from './CallExecutionStatus';
import {
    CallExecutionStatusFromJSON,
    CallExecutionStatusFromJSONTyped,
    CallExecutionStatusToJSON,
    CallExecutionStatusToJSONTyped,
} from './CallExecutionStatus';

/**
 * 
 * @export
 * @interface CallExecutionRecord
 */
export interface CallExecutionRecord {
    /**
     * 
     */
    call_id?: string;
    /**
     * 
     */
    lead_id?: string;
    /**
     * 
     */
    target_company?: TargetCompany;
    /**
     * 
     */
    goal_list?: Array<string>;
    /**
     * 
     */
    status?: CallExecutionStatus;
    /**
     * The ID of the user who initiated the call
     */
    user_id?: string;
    /**
     * The name of the user who initiated the call
     */
    user_name?: string;
    /**
     * 
     */
    conference_phone_numbers?: Array<string>;
    /**
     * The S3 key of the transcript
     */
    transcript_s3_key?: string;
    /**
     * The organization ID
     */
    organization_id?: string;
    /**
     * The status message to be displayed to the user
     */
    status_message?: string;
    /**
     * The analysis report data
     */
    report_data?: string;
    /**
     * Number of times this call was retried
     */
    retry_count?: number;
    /**
     * 
     */
    use_test_phone_numbers?: boolean;
    /**
     * 
     */
    structured_data?: StructuredAnalysisResponse;
    /**
     * 
     */
    request_body?: CreateCallExecutionRequest;
    /**
     * 
     */
    created_at?: Date;
    /**
     * 
     */
    updated_at?: Date;
    /**
     * The phone number that was called
     */
    target_phone_number?: string;
    /**
     * Whether the call execution was manually retried
     */
    manual_retry?: boolean;
    /**
     * 
     */
    additional_instructions?: InternalInstructions;
}



/**
 * Check if a given object implements the CallExecutionRecord interface.
 */
export function instanceOfCallExecutionRecord(value: object): value is CallExecutionRecord {
    return true;
}

export function CallExecutionRecordFromJSON(json: any): CallExecutionRecord {
    return CallExecutionRecordFromJSONTyped(json, false);
}

export function CallExecutionRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): CallExecutionRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'call_id': json['call_id'] == null ? undefined : json['call_id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'target_company': json['target_company'] == null ? undefined : TargetCompanyFromJSON(json['target_company']),
        'goal_list': json['goal_list'] == null ? undefined : json['goal_list'],
        'status': json['status'] == null ? undefined : CallExecutionStatusFromJSON(json['status']),
        'user_id': json['user_id'] == null ? undefined : json['user_id'],
        'user_name': json['user_name'] == null ? undefined : json['user_name'],
        'conference_phone_numbers': json['conference_phone_numbers'] == null ? undefined : json['conference_phone_numbers'],
        'transcript_s3_key': json['transcript_s3_key'] == null ? undefined : json['transcript_s3_key'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'status_message': json['status_message'] == null ? undefined : json['status_message'],
        'report_data': json['report_data'] == null ? undefined : json['report_data'],
        'retry_count': json['retry_count'] == null ? undefined : json['retry_count'],
        'use_test_phone_numbers': json['use_test_phone_numbers'] == null ? undefined : json['use_test_phone_numbers'],
        'structured_data': json['structured_data'] == null ? undefined : StructuredAnalysisResponseFromJSON(json['structured_data']),
        'request_body': json['request_body'] == null ? undefined : CreateCallExecutionRequestFromJSON(json['request_body']),
        'created_at': json['created_at'] == null ? undefined : (parseDateTime(json['created_at'])),
        'updated_at': json['updated_at'] == null ? undefined : (parseDateTime(json['updated_at'])),
        'target_phone_number': json['target_phone_number'] == null ? undefined : json['target_phone_number'],
        'manual_retry': json['manual_retry'] == null ? undefined : json['manual_retry'],
        'additional_instructions': json['additional_instructions'] == null ? undefined : InternalInstructionsFromJSON(json['additional_instructions']),
    };
}

export function CallExecutionRecordToJSON(json: any): CallExecutionRecord {
    return CallExecutionRecordToJSONTyped(json, false);
}

export function CallExecutionRecordToJSONTyped(value?: CallExecutionRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'call_id': value['call_id'],
        'lead_id': value['lead_id'],
        'target_company': TargetCompanyToJSON(value['target_company']),
        'goal_list': value['goal_list'],
        'status': CallExecutionStatusToJSON(value['status']),
        'user_id': value['user_id'],
        'user_name': value['user_name'],
        'conference_phone_numbers': value['conference_phone_numbers'],
        'transcript_s3_key': value['transcript_s3_key'],
        'organization_id': value['organization_id'],
        'status_message': value['status_message'],
        'report_data': value['report_data'],
        'retry_count': value['retry_count'],
        'use_test_phone_numbers': value['use_test_phone_numbers'],
        'structured_data': StructuredAnalysisResponseToJSON(value['structured_data']),
        'request_body': CreateCallExecutionRequestToJSON(value['request_body']),
        'created_at': value['created_at'] == null ? value['created_at'] : serializeDateTime(value['created_at']),
        'updated_at': value['updated_at'] == null ? value['updated_at'] : serializeDateTime(value['updated_at']),
        'target_phone_number': value['target_phone_number'],
        'manual_retry': value['manual_retry'],
        'additional_instructions': InternalInstructionsToJSON(value['additional_instructions']),
    };
}

